import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery } from '../../../utils';

export const OnlineInfo = () => {
  return (
    <Container>
      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon1}></NumberIcon>
          <Title>새틀라이트 참가 하기</Title>
        </TitleContainer>
        <Content>
          <ContentImg1 src={ImageUtils.GuideImg1} />
          <ContentText>아이콘이 달린 토너먼트에 골드를 내고 참여해주세요!</ContentText>
        </Content>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon2}></NumberIcon>
          <Title>새틀라이트에서 입상하고 메인/사이드 이벤트 티켓 획득하기</Title>
        </TitleContainer>
        <Content>
          <ContentImg2 src={ImageUtils.GuideImg2} />
          <ContentTextType2>
            <RedText>메인 새틀라이트</RedText>
            18 TO 1 <OnlyWeb>/</OnlyWeb>
            {` `}
            <OnlyMobile>
              <br />
            </OnlyMobile>
            <BlueText>사이드 새틀라이트</BlueText>
            10 TO 1<br /> 인더머니 순위를 기록하고{` `}
            <OnlyMobile>
              <br />
            </OnlyMobile>
            티켓과 아바타를 획득해주세요!
          </ContentTextType2>
        </Content>
        <WaringContainer>
          <WaringText>대회 별 최대 엔트리 수는 남은 티켓에 따라 변경됩니다.</WaringText>
          <WaringText>남은 최대 엔트리 수에 따라 엔트리가 불가능 할 수 있습니다.</WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon3}></NumberIcon>
          <Title>메인/사이드 이벤트 참가를 위한 개인 정보 동의 및 선수등록</Title>
        </TitleContainer>
        <Content>
          <ContentImg3 src={ImageUtils.GuideImg3} />
          <ContentText>
            티켓을 획득했다면 메인/사이드 이벤트 참가를 위한 개인정보 3자 제공 동의와 PFGT 선수
            등록을 진행해주세요!
          </ContentText>
        </Content>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon4}></NumberIcon>
          <Title>메인/사이드 이벤트 참가를 위한 참가자 번호 및 QR정보 확인 하기</Title>
        </TitleContainer>
        <Content>
          <ContentImg4 src={ImageUtils.GuideImg4} />
          <ContentText>
            메인/사이드 이벤트 티켓 획득 후 개인 정보 제공을 동의 했다면 참가자 번호 및 QR 정보 확인
            후 메인/사이드 이벤트에 참가해주세요!
          </ContentText>
        </Content>
      </Item>
    </Container>
  );
};

const Container = styled.div`
  max-width: 820px;
  margin: 0 auto;
`;

const Item = styled.div`
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);

  &:last-child {
    border-bottom: none;
  }

  ${mobileQuery} {
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
`;
const TitleContainer = styled.div`
  margin-bottom: 13px;
  ${mobileQuery} {
    margin-bottom: 6px;
  }
`;

const Title = styled.h3`
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.4px;

  ${mobileQuery} {
    font-size: 14px;
    line-height: 17px;
  }
`;

const ContentText = styled.h4`
  color: rgba(255, 255, 255, 0.6);
  font-size: 20px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: -0.4px;

  ${mobileQuery} {
    font-size: 13px;
    line-height: 18px;
  }
`;

const ContentTextType2 = styled(ContentText)`
  padding-top: 15px;
`;

const RedText = styled.span`
  color: #fd4896;
  font-weight: 700;
`;
const BlueText = styled.span`
  color: #3c91ff;
  font-weight: 700;
`;

const NumberIcon = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 7px;
  float: left;
  margin-top: 2px;

  ${mobileQuery} {
    width: 14px;
    height: 14px;
  }
`;
const ContentImg = styled.img`
  float: left;
  margin-right: 13px;
`;

const ContentImg1 = styled(ContentImg)`
  ${mobileQuery} {
    width: 140px;
  }
`;
const ContentImg2 = styled(ContentImg)`
  width: 195px;

  ${mobileQuery} {
    width: 180px;
  }
`;
const ContentImg3 = styled(ContentImg)`
  ${mobileQuery} {
    width: 150px;
  }
`;
const ContentImg4 = styled(ContentImg)`
  ${mobileQuery} {
    width: 150px;
  }
`;

const Content = styled.div`
  overflow: hidden;
`;

const WaringContainer = styled.ul`
  margin: 0;
  padding: 0;
  padding-left: 40px;
  margin-top: 15px;
  margin-bottom: 15px;

  ${mobileQuery} {
    padding-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
const WaringText = styled.li`
  color: #8e8e8e;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
  letter-spacing: -0.72px;

  ${mobileQuery} {
    font-size: 11px;
    line-height: 15px;
  }
`;

const OnlyMobile = styled.span`
  display: none;

  ${mobileQuery} {
    display: inline;
  }
`;

const OnlyWeb = styled.span`
  display: inline;

  ${mobileQuery} {
    display: none;
  }
`;
